import React, { useState } from "react";
import axios from "../../../../axios";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
export default function DeleteStudyPlanner({ event, close }) {
  const [thisPlanner, setThisPlanner] = useState(true);
  const [allPlanner, setAllPlanner] = useState(false);
  const [sucess, setSucess] = useState(false);
  const handlePlannerDelete = async () => {
    if (thisPlanner) {
      let res = await axios.delete(
        `/studyPlanner/${event?.studyPlanner_id}/lecture/delete/lectureId/${event?.lecture_id}`
      );
      console.log(res);
      if (res.status === 200) {
        // window.location.reload();
        setSucess(true);

      }
    } else {
      let res = await axios.delete(
        `/studyPlanner/${event?.studyPlanner_id}/lecture/deleteSeries/lectureId/${event?.lecture_id}`
      );
      console.log(res);
      if (res.status === 200) {
        // window.location.reload();
        setSucess(true);
      }
    }
  };
  let buttons = [
    {
      buttonModel: {
        content: "Yes",
        class: "discard_btn",
        isPrimary: true,
      },
      click: () => {
        handlePlannerDelete();
        // cose(false);
      },
    },
    {
      buttonModel: {
        content: "No",
        className: "create_claasBtn",
      },
      click: () => {
        close(false);
      },
    },
  ];
  let buttons1 = [
    {
      buttonModel: {
        content: "Okay",
        class: "discard_btn",
        isPrimary: true,
      },
      click: () => {
        window.location.reload();
        // cose(false);
      },
    },
  ];
  console.log(allPlanner, thisPlanner);
  return (
    <>
      <DialogComponent
        width={"800px"}
        style={{ marginTop: "300px", marginLeft: "300px" }}
        position={{ X: "center center", Y: "center center" }}
        allowDragging={true}
        showCloseIcon={true}
        open={() => close(true)}
        close={() => close(false)}
        buttons={buttons}
      >
        {/* <div className="SubContainerStudyPlaner p-4"> */}
        <div className="d-flex justify-content-center textStyling" style={{ fontSize: "25px" }}>
          Are you sure you want to Delete Study Planner?
        </div>
        {event?.Recurrence && (
          <div className="d-flex mt-5" style={{ marginLeft: "200px" }}>
            {/* <div className="mr-3">
            <RadioButtonComponent
              checked={thisPlanner}
              label="This Study Planner"
              onChange={() => {
                setThisPlanner(true);
                setAllPlanner(false);
              }}
            ></RadioButtonComponent>
            <span className="">This Study Planner</span>
          </div>
          <div>
            <RadioButtonComponent
              checked={allPlanner}
              label="This and Following Study Planner"
              onChange={() => {
                setAllPlanner(true);
                setThisPlanner(false);
              }}
            ></RadioButtonComponent>
            <span className="StdPlan mb-2">
              This and Following Study Planner
            </span>
          </div> */}
          </div>
        )}
        {/* <div className="d-flex justify-content-center mt-4 gap-2">
        <button
          className="yesNoBtnStudyPlaner"
          onClick={() => {
            handlePlannerDelete();
          }}
        >
          Yes
        </button>
        <button
          className="yesNoBtnStudyPlaner"
          onClick={() => {
            close(false);
          }}
        >
          No
        </button>
      </div> */}

        {/* <div className="RescheduleStudyPlanner">Reschedule Study Planner</div> */}
        {/* <div>
        <img
          className="crossIcon"
          src="/DCM-img/crossIcon.svg"
          alt="Up Arrow"
          onClick={() => {
            close(false);
          }}
        />
      </div> */}
        {/* </div> */}
      </DialogComponent>
      {sucess && (
        <DialogComponent
          width={"800px"}
          style={{ marginTop: "300px", marginLeft: "300px" }}
          position={{ X: "center center", Y: "center center" }}
          allowDragging={true}
          showCloseIcon={true}
          // open={() => close(true)}
          close={() => close()}
          buttons={buttons1}
        >
          <div style={{}}>
            <img
              src="/images/SucessDel.svg"
              alt=""
              style={{
                display: "flex",
                justifyContent: "center",
                marginLeft: "300px",
              }}
            />
            <p
              style={{
                width: "405px",
                height: "33px",
                fontWeight: "600",
                fontSiz: "24px",
                marginLeft: "260px",
                marginTop: "20px",
              }}
            >
              Study Planner Deleted Sucessfully
            </p>
          </div>
        </DialogComponent>
      )}
    </>

  );
}
